import { createRef, useEffect } from 'react';
import md5 from 'crypto-js/md5';

const AttributeName = 'data-hash';

const buildHash = (content: string): string => {
    if (content) {
        const ref = md5(content);
        return ref.toString();
    }

    return '';
};

const setHashAtt = (addHash: boolean, content: string) => {
    if (addHash) {
        return {
            [AttributeName]: buildHash(content),
        };
    }
    return {};
};

/**
 *
 * @param addHash A boolean to decide if to run this useEffect hook and add the hash
 * @param caption An optional caption that overrides the hook looking at the text content
 * @returns A ref to add to a control so the attribute can be added
 */
export function useHash<T>(addHash = false) {
    const ref = createRef<Element>();

    useEffect(() => {
        if (addHash) {
            ref.current?.setAttribute(AttributeName, buildHash(ref.current.textContent!));
        } else {
            ref.current?.removeAttribute(AttributeName);
        }
    }, [addHash, ref]);

    return {
        ref: (ref as unknown) as React.RefObject<T>,
        setHashAtt: (val: string) => {
            return setHashAtt(addHash, val);
        },
    };
}
